var PES = PES || {};
PES.BeautySlider = function () {
    function init(container, hasTooltips, navContainer, navAsThumbnails) {
        var options = {
            items: 1,
            mouseDrag: true,
            touch: true,
            autoplayButtonOutput: false,
            speed: 1000,
            loop: true,
            mode: 'gallery',
            navPosition: 'bottom'            
        }; 
        if (container) {
            options.container = container;
        }
        if (navContainer) {
            options.navContainer = navContainer;
        }
        if (options.navAsThumbnails) {
            options.navAsThumbnails = navAsThumbnails;
        }

        var slider = tns(options);

        var onSliderIndexChanged = function(info, eventName) {
            //remove and reinsert the pulsating circle elements (this is required in Safari, in order for the animation to work properly)
            const activeSlideCircles = $("div.slider-with-circles.tns-slide-active").children("span.circle-with-popup");
            if (activeSlideCircles.length > 0) {
                activeSlideCircles.each(function() {
                    const element = this;
                    const clone = element.cloneNode(true);
                    element.parentNode.replaceChild(clone, element);
                    //reinit the tooltip for cloned elements
                    if (hasTooltips) {
                        PES.ImageTooltip().initElement(clone);
                    }
                });
            }           
        };

        var resetToZeroIndex = function (info, eventName) {
                       
            if (info.index == 0) {               
                $(".made-with-pro-badge").addClass("is-shown");               
            } else {
                $(".made-with-pro-badge").removeClass("is-shown");
            }

            if (info.index == 1) {
                $(".made-with-pro-plus-badge").addClass("is-shown");
            } else {
                $(".made-with-pro-plus-badge").removeClass("is-shown");
            }

            if (info.index == 7 && $(info.container).hasClass('online-general-slider')) {
                slider.goTo('next');
                slider.goTo('prev');          
            }
        }

        var isSafari = navigator.vendor &&
            navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1;
        if (isSafari) {
            slider.events.on('indexChanged', onSliderIndexChanged);
        }

        slider.events.on('indexChanged', resetToZeroIndex);
    }
    return {
        init: init
    };
};